import {ImageCompressor} from "../../components/my_tools/img_compressor/imageCompressor";

interface IImgCompressor{
    globalTextColor: string;
}
export const ImgCompressor: React.FC<IImgCompressor> = ({globalTextColor}) => {

    return (
        <div className={`text-[${globalTextColor}]`}>
            <ImageCompressor />
        </div>
    )
}
